import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/hero.css';

import Hero1 from '../assets/hero/hero1.jpg';
import Hero2 from '../assets/hero/hero2.jpg';
import Hero3 from '../assets/hero/hero3.jpg';
import Hero4 from '../assets/hero/hero4.jpg';




const Hero = () => {
    const images = [Hero1, Hero2, Hero3, Hero4];
    const places = ['Heritage', 'Pilgrimage', 'Wildlife', 'Leisure'];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [searchInput, setSearchInput] = useState('');
    const [filteredPlaces, setFilteredPlaces] = useState(places);

    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 4000); // Update image and text every 4 seconds

        return () => clearInterval(interval);
    }, [images.length]);

    useEffect(() => {
        if (searchInput === '' || places.includes(searchInput)) {
            setFilteredPlaces([]); // Hide suggestions if the input matches a place or is empty
        } else {
            const filtered = places.filter((place) =>
                place.toLowerCase().includes(searchInput.toLowerCase()) // Filter places based on input
            );
            setFilteredPlaces(filtered);
        }
    }, [searchInput]);

    const handleSearchChange = (e) => {
        setSearchInput(e.target.value); // Update search input
    };

    const handleLocationSelect = (location) => {
        setSearchInput(location); // Set the input to selected location
        setFilteredPlaces([]); // Hide suggestions
    };

    const handleExplore = () => {
        if (places.includes(searchInput)) {
            navigate(`/destinations/${searchInput.toLowerCase()}`); // Navigate to the location route
        } else {
            alert('Please select a valid location from the suggestions.'); // Show alert if location is invalid
        }
    };

    return (
        <div className="hero-section">
            <div
                className="background-image"
                style={{
                    backgroundImage: `url(${images[currentIndex]})`,
                }}
            >
                <div className="overlay">
                    <div className="hero-container">
                        <div className="hero-container-left">
                            <h1>Book Your</h1>
                            <h1 className="slide-text">
                                Explore <span key={currentIndex}>{places[currentIndex]}</span>
                            </h1>
                            <div className="search-destination-container">
                                <div className="search-destination-texts">
                                    <span>Nature</span>
                                    <span>Wildlife</span>
                                    <span>Heritage</span>
                                    <span>Pilgrimage</span>
                                </div>
                                <p className="search-destination-description">Discover Madhya Pradesh – rich heritage, wildlife, and scenic beauty!</p>
                                <div className="search-destination-search">
                                    <input
                                        type="text"
                                        value={searchInput}
                                        onChange={handleSearchChange}
                                        placeholder="Type Catagories..."
                                    />
                                    <button onClick={handleExplore}>Explore</button>
                                    {/* Show suggestions when input does not match a valid place */}
                                    {searchInput && filteredPlaces.length > 0 && (
                                        <ul className="suggestions-list">
                                            {filteredPlaces.map((place) => (
                                                <li
                                                    key={place}
                                                    onClick={() => handleLocationSelect(place)} // Select a location
                                                >
                                                    {place}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="hero-container-right">
                            {/* Additional content if needed */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
